import { useSyncExternalStore } from 'react'

// Same values as the Tailwind breakpoints in src/styles/app.css.
export const BREAKPOINTS = {
  sm: 768,
  md: 1080,
  lg: 1280,
  xl: 1440,
} as const

export type Breakpoint = keyof typeof BREAKPOINTS

const queryFor = (breakpoint: Breakpoint) => `(min-width: ${BREAKPOINTS[breakpoint]}px)`

/** True when the viewport is at least as wide as the breakpoint (like Tailwind's `md:`). */
export const useBreakpoint = (breakpoint: Breakpoint): boolean => {
  const query = queryFor(breakpoint)
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false
  )
}
